/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_View_PlansInputs */

const en_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View plans`)
};

const de_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarife ansehen`)
};

const fr_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les offres`)
};

const es_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver planes`)
};

const it_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi i piani`)
};

const nl_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementen bekijken`)
};

const pl_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz plany`)
};

const fi_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä tilaukset`)
};

const da_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se planer`)
};

const sv_settings_view_plans = /** @type {(inputs: Settings_View_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa planer`)
};

/**
* | output |
* | --- |
* | "View plans" |
*
* @param {Settings_View_PlansInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_view_plans = /** @type {((inputs?: Settings_View_PlansInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_View_PlansInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_view_plans(inputs)
	if (locale === "fr") return fr_settings_view_plans(inputs)
	if (locale === "es") return es_settings_view_plans(inputs)
	if (locale === "it") return it_settings_view_plans(inputs)
	if (locale === "nl") return nl_settings_view_plans(inputs)
	if (locale === "pl") return pl_settings_view_plans(inputs)
	if (locale === "fi") return fi_settings_view_plans(inputs)
	if (locale === "da") return da_settings_view_plans(inputs)
	if (locale === "sv") return sv_settings_view_plans(inputs)
	return en_settings_view_plans(inputs)
});